import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withModifiers as _withModifiers, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys } from "vue"

const _hoisted_1 = {
  class: "productCard",
  "data-qa": "product-card-container"
}
const _hoisted_2 = ["data-qa", "onClick", "onKeydown", "aria-label"]
const _hoisted_3 = ["data-qa"]
const _hoisted_4 = ["data-qa"]
const _hoisted_5 = ["data-qa", "aria-label", "aria-pressed", "onClick"]
const _hoisted_6 = { class: "title-icons" }
const _hoisted_7 = ["data-qa"]
const _hoisted_8 = ["data-qa"]

import { Iphone, Monitor } from '@element-plus/icons-vue';
import { computed } from 'vue';
import { redirect } from '@/utils/ui';
import { useI18n } from 'vue-i18n';
import { updateRecentApps } from '@/utils/recentApps';
import { UseStoreUser } from '@/store/userStore';
import { UserInDb } from '@/types/UserInDb';
import type { UserApp } from '@/types/user';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductCard',
  props: {
    apps: {},
    searchKeyword: {},
    favoriteList: {}
  },
  emits: ["opened", "clicked"],
  setup(__props: any, { emit: __emit }) {

const phoneEnabledApps = ['teamsportailrh'];
const userStore = UseStoreUser();

const { t } = useI18n();

const props = __props;
const handleCommand = async (
  appLabel: string,
  command: string | number | object
) => {
  if (command == 'pin') {
    const userUpdated = Object.assign({}, userStore.userInDb);
    userUpdated.favorite = props.favoriteList
      ? [appLabel, ...props.favoriteList]
      : [appLabel];
    await updateUserFavorite(userUpdated);
  } else if (command == 'unpin') {
    const userUpdated = Object.assign({}, userStore.userInDb);
    userUpdated.favorite = props.favoriteList
      ? props.favoriteList.filter(favorite => favorite !== appLabel)
      : [];
    await updateUserFavorite(userUpdated);
  }
};
async function updateUserFavorite(userData: UserInDb) {
  try {
    await userStore.updateFavorite(userData);
    console.log('favorite updated successfully!');
  } catch (err) {
    console.log(err);
  }
}
const filteredApps = computed(() => {
  const list = props.apps || [];
  const filtered = list.filter(app =>
    app.label.toUpperCase().includes(props.searchKeyword.toUpperCase())
  );
  const favoriteListInApps = props.favoriteList
    ? filtered.filter(app => props.favoriteList!.includes(app.label))
    : [];
  const appsNotFavorite = filtered.filter(
    app => !props.favoriteList?.includes(app.label)
  );
  return [...favoriteListInApps, ...appsNotFavorite];
});

function isFavorite(item: string) {
  if (props.favoriteList) {
    return props.favoriteList.includes(item);
  }
  return false;
}

function togglePin(appLabel: string) {
  const command = isFavorite(appLabel) ? 'unpin' : 'pin';
  handleCommand(appLabel, command);
}

const emit = __emit;

function openApp(appId: string, url: string) {
  // Emit click event for Matomo tracking
  emit('clicked', appId);
  updateRecentApps(appId);
  emit('opened');
  setTimeout(() => redirect(url), 50);
}

return (_ctx: any,_cache: any) => {
  const _component_cs_pictogram = _resolveComponent("cs-pictogram")!
  const _component_cs_icon = _resolveComponent("cs-icon")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredApps.value, (app) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "card",
        key: app.label,
        "data-qa": `product-card-${app.label}`,
        role: "button",
        tabindex: "0",
        onClick: _withModifiers(($event: any) => (openApp(app.label, app.link)), ["stop"]),
        onKeydown: [
          _withKeys(_withModifiers(($event: any) => (openApp(app.label, app.link)), ["stop"]), ["enter"]),
          _withKeys(_withModifiers(($event: any) => (openApp(app.label, app.link)), ["prevent","stop"]), ["space"])
        ],
        "aria-label": app.displayLabel ?? app.label
      }, [
        _createElementVNode("div", {
          class: "card-content",
          "data-qa": `card-content-${app.label}`
        }, [
          _createElementVNode("div", {
            class: "card-header",
            "data-qa": `card-header-${app.label}`
          }, [
            _createVNode(_component_cs_pictogram, {
              height: "2.5rem",
              width: "2.5rem",
              name: app.pictoName,
              alt: app.label + ' logo',
              "data-qa": `app-logo-${app.label}`
            }, null, 8, ["name", "alt", "data-qa"]),
            _createElementVNode("div", {
              class: _normalizeClass(["card-actions", { 'card-actions--pinned': isFavorite(app.label) }])
            }, [
              _createElementVNode("button", {
                type: "button",
                class: "pin-btn",
                "data-qa": `pin-button-${app.label}`,
                "aria-label": 
                isFavorite(app.label) ? _unref(t)('dashboard.unpin') : _unref(t)('dashboard.pin')
              ,
                "aria-pressed": isFavorite(app.label),
                onClick: _withModifiers(($event: any) => (togglePin(app.label)), ["stop"])
              }, [
                _createVNode(_component_cs_icon, {
                  height: "1rem",
                  width: "1rem",
                  class: "pin",
                  name: isFavorite(app.label) ? 'epingle' : 'epinglable',
                  role: "presentation",
                  tabindex: "-1",
                  "aria-hidden": "true"
                }, null, 8, ["name"])
              ], 8, _hoisted_5)
            ], 2)
          ], 8, _hoisted_4),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", {
              class: "title",
              "data-qa": `app-name-${app.label}`
            }, _toDisplayString(app.displayLabel ?? app.label), 9, _hoisted_7),
            _createElementVNode("div", {
              class: "icons",
              "data-qa": `card-icons-${app.label}`
            }, [
              (phoneEnabledApps.includes(app.label))
                ? (_openBlock(), _createBlock(_component_el_icon, {
                    key: 0,
                    class: "icon",
                    "data-qa": `phone-icon-${app.label}`,
                    "aria-hidden": "true",
                    role: "img",
                    "aria-label": _unref(t)('productIcon.phoneIcon')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Iphone))
                    ]),
                    _: 1
                  }, 8, ["data-qa", "aria-label"]))
                : _createCommentVNode("", true),
              _createVNode(_component_el_icon, {
                class: "icon",
                "data-qa": `monitor-icon-${app.label}`,
                "aria-hidden": "true",
                role: "img",
                "aria-label": _unref(t)('productIcon.monitorIcon')
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Monitor))
                ]),
                _: 1
              }, 8, ["data-qa", "aria-label"])
            ], 8, _hoisted_8)
          ])
        ], 8, _hoisted_3)
      ], 40, _hoisted_2))
    }), 128))
  ]))
}
}

})